export const MAX_INTEGER_VALUE = 2147483647;

export const multiplyByHundredWithScalePrecision = (
  value?: number | null,
  toFixedValue?: number
) => (value ? +value.toFixed(toFixedValue) * 100 : null);

export const permyriadToPercent = (value: number) => value / 100;
